


















import { Component, Vue, Watch, Prop, Ref } from "vue-property-decorator";
import CField from "@/components/form/CField.vue";
import { FileApiSearchParams as IFileApiSearchParams } from "@/getinfo-api/fileManagerSearch";

@Component({
  components: {
    CField
  }
})
export default class CFileManagerFilter extends Vue {
  @Prop() id!: string;
  @Prop() currentDiskId!: string;
  activeLastFiles: boolean = false;
  searchString: string = "";

  getLastFiles() {
    this.activeLastFiles = !this.activeLastFiles;
    if (this.activeLastFiles) {
      let params: IFileApiSearchParams = {
        diskId: this.currentDiskId,
        sort: "modifiedAt",
        order: "DESC",
        limit: 30
      };
      this.$store.dispatch(`${this.id}/SEARCH_FILES_BY_FILTERS`, params);
    } else {
      this.$store.dispatch(`${this.id}/GET_DEFAULT_ITEMS`);
    }
  }

  @Watch("searchString")
  checkSearchString() {
    this.activeLastFiles = false;
    this.$store.dispatch(
      `${this.id}/SEARCH_FILE_BY_PATTERN`,
      this.searchString
    );
  }
  @Watch("currentDiskId")
  checkDiskId(prev: string, current: string) {
    if (prev != current) {
      this.activeLastFiles = false;
    }
  }
}
